
































import { Component, Vue } from 'vue-property-decorator';
import { workspaceService } from '@/services/WorkspaceService';

@Component({})
export default class PromocodeInfobox extends Vue {
  workspaceId = 0;
  isLoading = false;
  subject: any = '';
  formDescription: any = '';
  isBtnDisabled = false;
  isMailSendSuccessfully = false;

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.subject = this.$t('activation.trialContactRequest');
    this.formDescription = this.$t('activation.trialMessageSent');
  }
  closeModal() {
    this.isMailSendSuccessfully = false;
  }
  send() {
    const data = new FormData();
    data.append('type', this.subject);
    data.append('description', this.formDescription);

    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    workspaceService
      .createTicket(this.workspaceId, data)
      .then(() => {
        this.isLoading = false;
        this.isMailSendSuccessfully = true;
        this.isBtnDisabled = true;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
